import FeedIncident from "components/files/feed/FeedIncident";
import { trendingDemo } from "components/files/layout/TopNewsCard";
import FeedLayout from "layouts/files/FeedLayout";
import { useEffect, useState } from "react";
import { useNavigate, useParams } from "react-router-dom";
import { IconInput, TopNewsItem } from "ui";
import { demoCommunityListingImg } from "utils/assets_exports/images";
import { DemoComunityListObject } from "./CommunityListing";
import { CommunityList } from "components";

const SearchPage = () => {
    const params = useParams();
    const navigate = useNavigate();
    const [screen, setScreen] = useState<
        "trending" | "incidents" | "community"
    >("trending");
    const [search, setSearch] = useState("");
    useEffect(() => {
        setSearch(params.search || "");
    }, []);
    useEffect(() => {
        setSearch(params.search || "");
    }, [params.search]);

    const handleSubmit = (e: React.SyntheticEvent<HTMLFormElement>) => {
        e.preventDefault();
        if (search.length) {
            navigate(`/search/${search}`);
        } else {
            return;
        }
    };

    const demoUrGroups: DemoComunityListObject[] = [
        {
            newPosts: 11,
            title: "The family gamers world community",
            id: "@familygamers",
            members: "5.7k",
            img: demoCommunityListingImg[0]
        },
        {
            newPosts: 64,
            title: "Grandma's cake and cookies oven",
            id: "@grandmaoven",
            members: "12.9k",
            img: demoCommunityListingImg[1]
        },
        {
            newPosts: 21,
            title: "The house of casual fashionistas",
            id: "@casualfashionistas",
            members: "3.7k",
            img: demoCommunityListingImg[2]
        },
        {
            newPosts: 2,
            title: "Tales of fire, ice, and flying dragons",
            id: "@flyingdragons",
            members: "2.3k",
            img: demoCommunityListingImg[3]
        },
        {
            newPosts: 78,
            title: "Passionates of mountain trekking and adventure",
            id: "@passionatesofmountain",
            members: "6.1k",
            img: demoCommunityListingImg[4]
        },
        {
            newPosts: 45,
            title: "Keep your life balanced - for remote workers",
            id: "@lifebalanced",
            members: "78.5k",
            img: demoCommunityListingImg[5]
        },
        {
            newPosts: 68,
            title: "Latest straming releases and reviews",
            id: "@stramingreleases",
            members: "686.5k",
            img: demoCommunityListingImg[6]
        },
        {
            newPosts: 14,
            title: "Creative and healthy recipes for grown ups",
            id: "@familygamers",
            members: "15.7k",
            img: demoCommunityListingImg[7]
        }
    ];
    return (
        <FeedLayout pageTitle="">
            <div className="search-page">
                <div className={`map-pages-header`}>
                    <div className="d-flex flex-col flex-j-center flex-a-center mb-20 gap-10 w-full pr-10 pl-10">
                        <h1 className="fw-700 fs-100">
                            Search Results for: {params.search}
                        </h1>

                        <form
                            onSubmit={(e) => handleSubmit(e)}
                            className="w-full"
                        >
                            <IconInput
                                rounded
                                value={search}
                                handleChange={(
                                    e: React.ChangeEvent<HTMLInputElement>
                                ) => setSearch(e.target.value)}
                                handleSubmit
                                placeHolder="Search..."
                                svgColor="light-grey-svg"
                            />
                        </form>
                    </div>
                    <div className="box-heading mt-20 mb-30">
                        <div
                            className={`button${screen == "trending" ? " is-active" : ""}`}
                            onClick={() => setScreen("trending")}
                        >
                            Trending
                        </div>
                        <div
                            className={`button${screen == "incidents" ? " is-active" : ""}`}
                            onClick={() => setScreen("incidents")}
                        >
                            Incidents
                        </div>
                        <div
                            className={`button${screen == "community" ? " is-active" : ""}`}
                            onClick={() => setScreen("community")}
                        >
                            Community
                        </div>
                    </div>
                </div>

                {/* hashtag */}
                <div
                    className={
                        screen != "trending"
                            ? "is-hidden"
                            : "card pb-20 pr-20 pl-20 pt-20"
                    }
                >
                    <div className="card-body no-padding">
                        {trendingDemo.map((i) => (
                            <TopNewsItem item={i} />
                        ))}
                    </div>
                </div>

                {/* incidents */}
                <div className={screen != "incidents" ? "is-hidden" : "pb-40 "}>
                    <FeedIncident />
                    <FeedIncident />
                    <FeedIncident />
                </div>

                {/* community */}
                <div
                    className={
                        screen != "community"
                            ? "is-hidden"
                            : "groups-grid h-full community-listing-page"
                    }
                >
                    <div className="columns is-multiline pb-20 ">
                        {demoUrGroups.map((i) => (
                            <CommunityList listItem={i} key={i.id} />
                        ))}
                    </div>
                </div>
            </div>
        </FeedLayout>
    );
};

export default SearchPage;
